document.querySelectorAll('.media-banner__wrapper[data-video-autoplay="true"]').forEach((wrapper) => {
  wrapper.querySelectorAll('.media-banner__video').forEach((video) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play()?.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(video);
  });
});
